import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { HttpService } from 'src/app/services/http.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-recetas-paginadas',
  templateUrl: './recetas-paginadas.component.html',
  styleUrls: ['./recetas-paginadas.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RecetasPaginadasComponent implements OnInit {
  @Input() section: any = undefined;
  @Input() category: any = undefined;
  @Input() catalogueId: string;
  public actualPage: number = 1;
  public totalPages = 1;
  public domainId = environment.domainId;
  public galleries: any[] = [];

  constructor(private httpSv: HttpService, private cdr: ChangeDetectorRef) {}

  ngOnInit() {
    this.getCatalogue();
  }

  async getCatalogue() {
    try {
      const params = {
        domainId: this.domainId,
        catalogueId: this.catalogueId,
        pag: this.actualPage,
        categoryId: this.category,
      };

      const res: any = await this.httpSv.itemIndex(
        'client',
        'search',
        params,
        'galleries/'
      );
      const data = res.data;
      this.galleries = data.data;
      this.totalPages = data.meta.last_page;
      this.cdr.detectChanges();
    } catch (err) {
      console.error(err);
    }
  }

  async changePage(ev) {
    try {
      this.actualPage = ev;
      await this.getCatalogue();
    } catch (err) {
      console.error(err);
    }
  }
}
